import {
  currencySchema,
  currencyUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { DEFAULT_TITLE_OPTS, titleWithNameUI } from '../../../../definitions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['dependent-info--education-title'];
const INPUT_LABELS = {
  enrollment: strWithYear(content['dependent-info--enrollment-label']),
  expenses: content['dependent-info--expenses-label'],
};
const HINT_TEXT = strWithYear(content['dependent-info--expenses-hint']);

const { attendedSchoolLastYear, dependentEducationExpenses } =
  FULL_SCHEMA.properties.dependents.items.properties;

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.dependents),
    attendedSchoolLastYear: yesNoUI(INPUT_LABELS.enrollment),
    dependentEducationExpenses: currencyUI({
      title: INPUT_LABELS.expenses,
      hint: HINT_TEXT,
      min: dependentEducationExpenses.minimum,
      max: dependentEducationExpenses.maximum,
    }),
  },
  schema: {
    type: 'object',
    required: ['dependentEducationExpenses'],
    properties: {
      attendedSchoolLastYear,
      dependentEducationExpenses: currencySchema,
    },
  },
};
